
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".9","d":"M9.955 1.867H2.49c-.688 0-1.245.557-1.245 1.244v2.825a6.637 6.637 0 003.293 5.733l1.058.617c.387.226.866.226 1.254 0l1.058-.617A6.637 6.637 0 0011.2 5.936V3.111c0-.687-.557-1.244-1.245-1.244z","stroke":"#122546","stroke-width":"1.5"}})])
          )
        }
      }
    